/**
 * Curated reference vocabularies for "should-be-a-managed-list" fields.
 *
 * These back creatable comboboxes (an <input> + <datalist>) rather than rigid
 * <select>s — so they SUGGEST the standard values (normalising data entry) while
 * still preserving any existing free-text value a record already holds. Same
 * pattern as the asset "Make" manufacturer combobox. Plain data, no logic
 * depends on the contents — extend freely.
 */
// Standard inventory units of measure (ISO-ish), for stockroom consumables.
export const UNITS_OF_MEASURE = [
    'each', 'box', 'pack', 'case', 'set', 'pair', 'roll', 'reel',
    'bag', 'bottle', 'tube', 'metre', 'centimetre', 'litre', 'millilitre',
    'kilogram', 'gram',
];
// Common B2B industry sectors for the client master (loosely NAICS-aligned).
export const INDUSTRIES = [
    'Retail', 'Healthcare', 'Financial Services', 'Manufacturing', 'Technology',
    'Education', 'Government', 'Hospitality', 'Logistics & Transport',
    'Energy & Utilities', 'Telecommunications', 'Construction',
    'Professional Services', 'Media & Entertainment', 'Non-profit',
    'Real Estate', 'Automotive', 'Pharmaceuticals', 'Agriculture', 'Other',
];
